import type {Dispatch, SetStateAction} from "react";
import {createContext, createRef} from "react";

const ref = createRef<[boolean, Dispatch<SetStateAction<boolean>>]>();
export const WorkingStateContext = createContext(ref);
